import { Notify } from "@flexisaf/flexibull2/build/notify";
import { call, put, takeLatest } from "redux-saga/effects";
import { postEdit } from "../../../services/examGroup";
import { editGroupStart, editGroupSuccess, editGroupFailure } from "../reducer";

export function* editGroup({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postEdit, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editGroupSuccess());
    Notify("Group edited successfully", { status: "success" });
    if (callback) {
      callback();
    }
  } else {
    yield put(editGroupFailure(message || raw.error));
    Notify(message || raw.error, { status: "error" });
  }
}

export default function* onEditGroup() {
  yield takeLatest(editGroupStart.type, editGroup);
}
